<template>
<div>
  <v-dialog fullscreen v-model="dialog">

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{field.name}}
        <v-icon @click="clear">refresh</v-icon>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="dialog = false">
          Ok
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div ref="canvasWrapper" class="signature-wrapper">
          <canvas ref="canvas" id="canvas" height="1" width="1"></canvas>
        </div>
      </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="dialog = false">
        Ok
      </v-btn>
    </v-card-actions>
    </v-card>
  </v-dialog>
  <span>{{field.name}}</span>
  <v-btn :color="model ? 'green' : 'white'" icon @click="dialog=true"><v-icon>{{ model ? 'check' : 'edit'}}</v-icon></v-btn>
</div>
</template>

<script>
import {input} from '@/mixins/input'

export default {
  mixins: [input],
  data() {
    return {
      model :null,
      dialog: false,
      isDrawing: false,
      ctx: {},
      canvas: null,
      x: 0,
      y: 0
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  created() {
    this.model = this.value

    if (this.model != undefined && this.model.length > 10) {
      var image = new Image();
      image.onload = () => {
        this.ctx.drawImage(image, 0, 0);
      };

      image.src = 'data:image/png;base64,' + this.model
    }
  },
  mounted() {
    this.canvas = this.$refs.canvas
    this.ctx = this.canvas.getContext("2d");
    new ResizeObserver(this.onCanvasResize).observe(this.$refs.canvasWrapper)

    let downFn = event => {
      let offset =  this.getCanvasOffset()
      this.ctx.beginPath();
      this.ctx.moveTo(event.pageX - offset.x, event.clientY - offset.y);
      this.isDrawing  = true;
    }

    this.canvas.addEventListener('mousedown', downFn,false);
    this.canvas.addEventListener('touchstart', e => {downFn(e.touches[0]); e.preventDefault()},false);

    let moveFn = event => {
      if (this.isDrawing === true) {
        let offset = this.getCanvasOffset()
        this.ctx.lineTo(event.pageX - offset.x, event.clientY - offset.y)
        this.ctx.stroke()
      }
    }

    this.canvas.addEventListener('mousemove', moveFn,false)
    this.canvas.addEventListener('touchmove',  e => {moveFn(e.touches[0]); e.preventDefault()},false)

    let endFn = event => {
      if (this.isDrawing === true) {
        this.ctx.moveTo(event.pageX - this.canvas.offsetLeft, event.clientY - this.canvas.offsetTop);
        this.x = 0;
        this.y = 0;
        this.isDrawing = false;
        this.model = this.getBas64Image();
      }
    }

    window.addEventListener('mouseup', endFn,false);
    window.addEventListener('touchend', e => endFn(e.changedTouches[0]),false);
  },
  methods: {
    clear() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    },
    getBas64Image() {
      return this.canvas.toDataURL().split(';base64,')[1]
    },
    drawLine(context, x1, y1, x2, y2) {
      this.ctx.beginPath()
      this.ctx.strokeStyle = 'black'
      this.ctx.lineWidth = 1
      this.ctx.moveTo(x1, y1)
      this.ctx.lineTo(x2, y2)
      this.ctx.stroke()
      this.ctx.closePath()
    },
    onCanvasResize() {
      let width = this.$refs.canvasWrapper.clientWidth
      let height = this.$refs.canvasWrapper.clientHeight
      this.canvas.setAttribute('width', width * 0.97)
      this.canvas.setAttribute('height', height * 0.97)

    },
    getCanvasOffset() {
      let totalOffsetX = 0
      let totalOffsetY = 0
      let currentElement = this.canvas
      do {
        totalOffsetX += currentElement.offsetLeft - currentElement.scrollLeft
        totalOffsetY += currentElement.offsetTop - currentElement.scrollTop
      }
          // eslint-disable-next-line no-cond-assign
      while (currentElement = currentElement.offsetParent)

      return {x: totalOffsetX, y: totalOffsetY}
    }
  },
}
</script>

<style>
.signature-wrapper {
  width: 80%;
  height: 400px;
  border: 1px dotted black;
  overflow: hidden;
}

.field-name {
  font-size: 18px;
}
</style>
